import BaseModelAPI from '../BaseModelAPI';

export default class Rack extends BaseModelAPI {
	static entity = 'rack';
	static entityName = 'rack';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.code = '';
			this.name = '';
			this.areaId = '';
			this.area = {};
			this.customerId = '';
			this.customer = {};
			this.lineId = '';
			this.line = {};
			this.partId = '';
			this.part = {};
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}